export type RNFBSDKCallback = {
  isCancelled: boolean;
};
